import React, { useState } from 'react';
import {
  vertical_line,
  vertical_first_line
} from '../../TeamPerformance/TeamPerformanceTable/TeamPerformance.module.css';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
const IndividualColumnData = () => {
  const commonHeaderStyle = 'w-full  items-end mx-auto text-center',
    commonStyle = 'w-full mx-auto text-center',
    leftStyle = 'w-full mx-auto text-left',
    commonparentGruopStyle =
      '  mx-auto text-center  mb-2 text font-khand font-sm text-black-500 font-semibold absolute ',
    commonColStyle =
      ' mt-2 text-black-500 text-sm  font-khand font-normal overflow-auto';

  const commonParentGroupStyle = {
    fontWeight: 500,
    fontSize: '14px',
    bottom: '34px'
  };
  const colStyle = { fontWeight: '500', opacity: '0.8' };

  const HeaderCommonFormat = ({
    majorColName = '',
    colName,
    colNameClass = ''
  }) => (
    <div className={`${commonHeaderStyle} `}>
      <p
        className={`${commonparentGruopStyle} `}
        style={commonParentGroupStyle}
      >
        {majorColName}
      </p>
      <p
        className={`${commonColStyle} ${colNameClass} 
        
        `}
        style={colStyle}
      >
        {colName}
      </p>
    </div>
  );
  const verticalLine = {
    width: '10px !important',
    style: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      width: '12px !important'
    }
  };

  return [
    {
      name: <HeaderCommonFormat colName="Month" />,
      selector: 'month',
      sortable: false,
      cell: row => {
        return (
          <p className={`${leftStyle} break-normal text-left ml-2`}>
            {moment(row?.targetMonth).format('MMMM YY') || '---'}
          </p>
        );
      },
      minWidth: '100px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Funnel" />,
      selector: 'funnel',
      sortable: false,
      cell: row => (
        <div className={commonStyle}>
          <FontAwesomeIcon icon={faFilter} style={{ color: '#B2B2B2' }} />
        </div>
      ),
      width: '40px !important'
    },
    {
      name: <HeaderCommonFormat colName="BP" />,
      selector: 'bp',
      sortable: false,
      cell: row => (
        <p className={commonStyle}>{row.bpCount ? row.bpCount : 0}</p>
      ),
      width: '60px !important'
    },
    {
      name: <HeaderCommonFormat colName="Txn. BP" />,
      selector: 'txnBp',
      sortable: false,
      cell: row => (
        <p className={commonStyle}>{row.tranxBpCount ? row.tranxBpCount : 0}</p>
      ),
      width: '50px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Leads" majorColName="Number" />,
      selector: 'leadsTotalCount',
      sortable: false,
      cell: row => <p className={commonStyle}>{row?.leadsTotalCount || 0}</p>,
      width: '60px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Rej." />,
      selector: 'leadsRejectCount',
      sortable: false,
      cell: row => <p className={commonStyle}>{row?.leadsRejectCount || 0}</p>,
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Logins" />,
      selector: 'leadsLoginCount',
      sortable: false,
      cell: row => <p className={commonStyle}>{row?.leadsLoginCount || 0}</p>,
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'leadsSanctionCount',
      sortable: false,
      cell: row => (
        <p className={commonStyle}>{row?.leadsSanctionCount || 0}</p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Disb." />,
      selector: 'leadsDisbursedCount',
      sortable: false,
      cell: row => (
        <p className={commonStyle}>{row?.leadsDisbursedCount || 0}</p>
      ),
      width: '50px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Leads" majorColName="Amount" />,
      selector: 'leadsLoanAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal mx-8 text-right `}>
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Rej." />,
      selector: 'leadsRejectLoanAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right `}>
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsRejectLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },

    {
      name: <HeaderCommonFormat colName="Logins" />,
      selector: 'leadsLoginLoanAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right `}>
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsLoginLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },

    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'leadsSanctionLoanAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right `}>
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsSanctionLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: (
        <div className="w-full pr-2">
          <HeaderCommonFormat colName="Disb." />
        </div>
      ),
      selector: 'leadsDisbursedLoanAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right pr-2`}>
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsDisbursedLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="GR" />,
      selector: 'gr',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}`}>
          {row?.gr ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.gr) || '---'}</span>
        </p>
      )
    },
    {
      name: <HeaderCommonFormat colName="Payout" />,
      selector: 'payout',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}`}>
          {row?.payout ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.payout) || '---'}</span>
        </p>
      )
    },
    {
      name: <HeaderCommonFormat colName="NR" />,
      selector: 'nr',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}`}>
          {row?.nr ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.nr) || '---'}</span>
        </p>
      )
    },
    {
      name: <HeaderCommonFormat colName="Comp." />,
      selector: 'comp',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}`}>
          {row?.comp ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.comp) || '---'}</span>
        </p>
      )
    },
    {
      name: <HeaderCommonFormat colName="Multiple" />,
      selector: 'multiple',
      sortable: false,
      cell: row => {
        let specificStyles = '';
        let parseFloatMultiple = parseFloat(row?.multiple);
        if (parseFloatMultiple >= 3) {
          specificStyles = 'text-green-600 bg-green-200';
        } else if (parseFloatMultiple < 3 && parseFloatMultiple >= 2) {
          specificStyles = 'text-orange-600 bg-orange-50';
        } else if (parseFloatMultiple < 2) {
          specificStyles = 'text-red-400 bg-red-600';
        } else {
          specificStyles = 'text-red-400 bg-red-600';
        }
        return (
          <p className={`${commonStyle} ${specificStyles} p-1 rounded-sm`}>
            {row?.multiple !== null ? parseFloatMultiple + 'x' : '---'}
          </p>
        );
      }
    },
    {
      name: <HeaderCommonFormat colName="Net Margin" />,
      selector: 'netMargin',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}`}>
          {row?.netMargin ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.netMargin) || '---'}</span>
        </p>
      )
    }
  ];
};

export default IndividualColumnData;
